export default function() {
    return {
        notifications: []
    }
}